import getCustomIcon from 'lib/seats/getCustomIcon';

function generateIconMarkup(el, icon, coords, classNames) {
  if (!icon) {
    return;
  }

  var bBox = icon.bBox;
  var dimensions = {
    x: coords.x - bBox.width / 2,
    y: coords.y - bBox.height / 2,
    width: bBox.width,
    height: bBox.height
  };

  var svgNs = 'http://www.w3.org/2000/svg';
  var parent = el.parentNode;

  // Create new group to position icon
  var newElement = document.createElementNS(svgNs, 'g');
  newElement.setAttribute(
    'transform',
    `translate(${dimensions.x}, ${dimensions.y})`
  );
  newElement.setAttribute(
    'class',
    `syos-custom-icon syos-custom-icon--${icon.name} ${classNames.join(' ')}`
  );

  // Transfer path data to new element
  var pathElement = document.createElementNS(svgNs, 'path');
  pathElement.setAttribute('d', icon.pathData);

  // Create a transparent background element to increase hit area
  var rectElement = document.createElementNS(svgNs, 'rect');
  rectElement.setAttribute('fill', 'transparent');
  rectElement.setAttribute('width', dimensions.width);
  rectElement.setAttribute('height', dimensions.height);

  // Build the icon node
  newElement.appendChild(pathElement);
  newElement.appendChild(rectElement);

  // Append the new element to the parent
  parent.appendChild(newElement);

  return newElement;
}

export default function renderCustomIcon(iconId, el, classNames) {
  var icon = getCustomIcon(iconId);
  let coords = { x: el.getAttribute('cx'), y: el.getAttribute('cy') };

  if (el.tagName.toLowerCase() === 'rect') {
    let width = parseInt(el.getAttribute('width'), 10);
    let height = parseInt(el.getAttribute('height'), 10);
    if (width > 0) {
      coords = {
        x: parseInt(el.getAttribute('x'), 10) + width / 2,
        y: parseInt(el.getAttribute('y'), 10) + height / 2
      };
    } else {
      coords = {
        x: -1000000,
        y: -1000000
      };
    }
  }

  let d = el.getAttribute('d');
  if (d) {
    let splited = d.substr(1).split(',');
    if (splited.length > 1) {
      let sizeOffset = 4;
      if (splited[1].indexOf('c') !== -1) {
        sizeOffset = splited[1].indexOf('c');
      } else if (splited[1].indexOf('a')) {
        sizeOffset = splited[1].indexOf('a');
      }

      let size = parseFloat(splited[1].substr(sizeOffset + 1));
      coords.x = parseFloat(splited[0]);
      coords.y = parseFloat(splited[1]) + size;
    }
  }
  var newIcon = generateIconMarkup(el, icon, coords, classNames);
  return newIcon;
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/seats/renderCustomIcon.js